/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

// Modular Dimensions of Dialogs: https://confluence.veeam.com/display/CT/Modular+Dimensions+of+Dialogs + extensions
export const MODAL_SIZE_XXS = { width: '288px', height: '160px' };
export const MODAL_SIZE_XS = { width: '480px', height: '260px' };
export const MODAL_SIZE_S = { width: '600px', height: '320px' };
export const MODAL_SIZE_MS = { width: '640px', height: '496px' };
export const MODAL_SIZE_M = { width: '720px', height: '400px' };
export const MODAL_SIZE_L = { width: '800px', height: '432px' };
export const MODAL_SIZE_XL = { width: '880px', height: '560px' };
export const MODAL_SIZE_XXL = { width: '960px', height: '700px' };
export const MODAL_SIZE_XXXL = { width: '1120px', height: '800px' };
export const MODAL_SIZE_XXXXL = { width: '1200px', height: '848px' };

// Grid
export const DEFAULT_PAGINATION_LIMIT = 100;
export const DEFAULT_AUTO_UPDATE_INTERVAL = 60000;
export const AUTO_UPDATE_KEY = 'rcopAutoUpdate';

export const CONTROL_SIZE_XXS_PLUS = '100px';
export const CONTROL_SIZE_XXM = '192px';
